const initialState = {
	frame_icons: {},
	frame_shapes: {},
	frame_colors: {}
};

const EntityIcons = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case "GET_FRAME_ICONS": {
			const { icons, type } = payload;
			return {
				...state,
				[type]: { ...state[type], ...icons }
			};
		}
		case "GET_FRAME_SHAPES": {
			const { shapes, type } = payload;
			return {
				...state,
				[type]: { ...state[type], ...shapes }
			};
		}
		case "GET_FRAME_COLORS": {
			const { colors, type } = payload;
			return {
				...state,
				[type]: { ...state[type], ...colors }
			};
		}

		default:
			return state;
	}
};

export default EntityIcons;
